//# sourceMappingURL=info.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/info.interface.js
// module id = 1174
// module chunks = 4